import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=b0477498&lang=pug&"
import script from "./hint.vue?vue&type=script&setup=true&lang=js&"
export * from "./hint.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=b0477498&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports